var map = {
	"./head-controller.js": 313,
	"./head-controller.js.coffee": 313,
	"./layout-controller.js": 314,
	"./layout-controller.js.coffee": 314,
	"./lti-confirm-controller.js": 315,
	"./lti-confirm-controller.js.coffee": 315,
	"./partner_notification_controller.js": 316,
	"./partner_notification_controller.js.coffee": 316,
	"./static-controller.js": 317,
	"./static-controller.js.coffee": 317,
	"./subscriptions-controller.js": 318,
	"./subscriptions-controller.js.coffee": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;